<div>
  @if (hasAllRsvps) {
    <se-fe-accordion
      [seFeDataTitle]="rsvpAccordionTitle"
      [seFeDataExpanded]="rsvpListOpen"
      (seFeExpandedChange)="toggleAccordion()">
      @if (!rsvpListOpen) {
        <div seFeAccordionHeaderActions class="rsvpAccordionHeader">
          @for (rsvp of headerAvatars; track rsvp) {
            <div>
              @if (rsvp.response !=='no_response') {
                <se-fe-avatar
                  seFeDataType="persona"
                  [seFeDataIdentity]="rsvp.identity"
                  seFeDataSize="200"
                  [seFeDataBorder]= true
                  [seFeDataStatusIcon]="rsvpIcons[rsvp.id].icon"
                  [seFeDataStatusColor]="rsvpIcons[rsvp.id].color"
                  class="avatarGroup">
                </se-fe-avatar>
              }
              @if (rsvp.response === 'no_response') {
                <se-fe-avatar
                  seFeDataType="persona"
                  [seFeDataIdentity]="rsvp.identity"
                  seFeDataSize="200"
                  [seFeDataBorder]= true
                  class="avatarGroup">
                </se-fe-avatar>
              }
            </div>
          }
          @if (additionalAvatars) {
            <se-fe-avatar
              seFeDataType="general"
              [seFeDataIdentity]="additionalAvatars"
              seFeDataSize="200"
              [seFeDataBorder]= true
              class="avatarGroup">
            </se-fe-avatar>
          }
        </div>
      }
      <div *seFeAccordionContent>
        <se-fe-list>
          @for (rsvp of rsvps; track rsvp) {
            <se-fe-list-item [rsvp]="rsvp">
              <app-rsvp-list-item [rsvp]="rsvp" (onRsvp)="emitEvent($event)"></app-rsvp-list-item>
            </se-fe-list-item>
          }
        </se-fe-list>
      </div>
    </se-fe-accordion>
  }

  @if (!hasAllRsvps && rsvps.length) {
    <div>
      <se-fe-list>
        <se-fe-list-item>
          <se-fe-header size="600" seFeDataTitle="Are You Going?"></se-fe-header>
        </se-fe-list-item>
        @for (rsvp of rsvps; track rsvp) {
          <se-fe-list-item>
            <app-rsvp-list-item [rsvp]="rsvp" (onRsvp)="emitEvent($event)"></app-rsvp-list-item>
          </se-fe-list-item>
        }
      </se-fe-list>
    </div>
  }
</div>
